import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/404.vue';
import CrmPage from '../views/CrmPage.vue';
// import ClientDashboard from '../views/ClientDashboard.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
// import HumanResource from  '../views/HumanResource.vue'
import JobManagement from  '../views/JobManagement.vue'
import JobStartEnd from  '../views/JobStartEnd.vue'
import Booking from  '../views/Booking.vue'
import Landing from '../views/Landing.vue'
// import SignUp from "../views/SignUp.vue"
import Inventory from "../views/Inventory.vue"
import SignDoc from "../views/SignDoc.vue"
import AdminVoucher from "../views/AdminVoucher.vue"
import Tutorial from "../views/Tutorial.vue"
import Success from "../views/Success.vue"
import DriverJob from "../views/DriverJob.vue"
import EditSignDoc from "../views/EditSignDoc.vue"
import JobList from "../views/JobList.vue"
import JobFullList from "../views/JobFullList.vue"
import AdminNewVoucher from "../views/AdminNewVoucher.vue"
import DriverVoucher from "../views/DriverVoucher.vue"
import DriverNewVoucher from "../views/DriverNewVoucher.vue"
import DriverVoucherList from "../views/DriverVoucherList.vue"
import JobManagementAdmin from "../views/JobManagementAdmin.vue"
import EmailInbox from "../views/EmailInbox.vue"


const routes = [
  { path: '/',component: Landing },
  { path: '/login',component: Home },
  { path: '/crm', component: CrmPage },
  // { path: '/SignUp', component: SignUp, name: 'SignUp' },
  // { path: '/clientDashBoard/:id', component: ClientDashboard, name: 'ClientDashboard' },
  // { path: '/HumanResource', component: HumanResource },
  { path: '/JobManagement', component: JobManagement },
  { path: '/JobManagementAdmin/:token', component: JobManagementAdmin },
  { path: '/EmailInbox', component: EmailInbox },
  { path: '/DriverJob', component: DriverJob },
  { path: '/SignDoc/:jobId/:token', component: SignDoc },
  { path: '/EditSignDoc/:id/:token', component: EditSignDoc },
  { path: '/JobList/:token', component: JobList },
  { path: '/JobFullList/:token', component: JobFullList },
  { path: '/Success/:jobId/:token', component: Success },

  { path: '/AdminVoucher/:voucherId', component: AdminVoucher },
  { path: '/AdminNewVoucher/:id', component: AdminNewVoucher },
  { path: '/DriverVoucher/:voucherId', component: DriverVoucher },
  { path: '/DriverNewVoucher/:id', component: DriverNewVoucher },
  { path: '/DriverVoucherList', component: DriverVoucherList },


  { path: '/JobStartEnd/:id/:token', component: JobStartEnd },
  { path: '/Booking', component: Booking },
  { path: '/Inventory', component: Inventory },
  { path: '/ForgetPassword', component: ForgetPassword },
  { path: '/Tutorial', component: Tutorial },
  
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
